<template>
    <div id="form">
        <div class="material-icons time-icon">list</div>
        <div class="content">
            <div class="header" @click="changeVisible">
                <div class="header-titles">
                    <span class="header-title">{{ $t("calendar.resForm") }}</span>
                    <span class="header-sub-title">{{ $t("calendar.resFormDesc") }}</span>
                </div>
                <div class="material-icons" v-if="contentVisible">expand_less</div>
                <div class="material-icons" v-else>expand_more</div>
            </div>
            <div v-if="contentVisible" class="form-items">
                <div class="container">
                    <div v-for="(formItem, index) in cloneFormInputs" class="form-item">
                        {{ formItem.label }}{{ formItem.required ? " *" : "" }}
                        <span
                            class="material-icons form-item-icon edit"
                            @click="editFormInput(formItem, index)"
                            v-if="!formItem.isDefault"
                            >edit</span
                        >
                        <span
                            class="material-icons form-item-icon"
                            @click="closeFormInput(index)"
                            v-if="!formItem.isDefault"
                            >close</span
                        >
                    </div>
                </div>
                <SupsisButton @click="showModal = true" style="cursor: pointer"> + {{ $t("calendar.addAnItem") }}</SupsisButton>
            </div>
        </div>
        <Modal2
            id="form-modal"
            v-if="showModal || editModal"
            :showTitle="false"
            :show-footer="false"
            @cancel="closeModal"
        >
            <FormModal @close="closeModal" @input="saveItem($event)" :data="editFromItem" />
        </Modal2>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { log2 } from "../../../../../utils/log2";
import Modal2 from "../../../../../components/common/Modal2.vue";
import SupsisButton from "../../../../../components/common/SupsisButtonOld.vue";
import FormModal from "./FormModal.vue";
import _ from "lodash";
import { CALENDAR_API } from "../../../../../api/calendar";

const log = log2("Form");
export default {
    name: "Form",
    components: { SupsisButton, Modal2, FormModal },
    props: {
        value: { type: Array, required: true },
    },
    data() {
        return {
            description: "",
            contentVisible: false,
            showModal: false,
            editModal: false,
            editFromItem: {},
            editFromItemIndex: "",
            cloneFormInputs: _.cloneDeep(this.value),
        };
    },
    methods: {
        closeModal() {
            this.showModal = false;
            this.editModal = false;
            this.editFromItem = {};
        },
        editFormInput(formItem, index) {
            log("editFormInput");
            this.editModal = true;
            this.editFromItem = formItem;
            this.editFromItemIndex = index;
        },
        closeFormInput(index) {
            this.cloneFormInputs = this.cloneFormInputs.filter((_, i) => i !== index);
        },
        saveItem(cloneFormInputs) {
            if (this.editModal) {
                this.cloneFormInputs = this.cloneFormInputs.map((item, index) => {
                    if (index === this.editFromItemIndex) {
                        return {
                            type: cloneFormInputs.type,
                            label: cloneFormInputs.label,
                            required: cloneFormInputs.required,
                        };
                    }
                    return item;
                });
            } else {
                this.cloneFormInputs = [
                    ...this.cloneFormInputs,
                    {
                        type: cloneFormInputs.type,
                        label: cloneFormInputs.label,
                        required: cloneFormInputs.required,
                    },
                ];
            }
            this.closeModal();
        },
        changeVisible() {
            this.contentVisible = !this.contentVisible;
        },
    },
    async mounted() {},
    beforeDestroy() {},
    watch: {
        cloneFormInputs: {
            handler: function (val) {
                this.$emit("input", val);
            },
            deep: true,
        },
    },
};
</script>

<style>
#form-modal {
    .custom-modal-body {
        border-radius: 20px;
        background-color: white;
    }
}
</style>

<style lang="scss" scoped>
#supsis-button.small {
    padding: 6px 10px;
    border-radius: 10px;
}

#form {
    display: flex;
    flex-direction: row;
    margin-top: 20px;
    height: 100%;

    .time-icon {
        margin-top: 7px;
        margin-right: 20px;
        font-size: 20px;
    }

    .content {
        .header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-direction: row;
            cursor: pointer;
            border-radius: 5px;
            padding: 5px;

            &:hover {
                background-color: #e3e3e3;
            }

            .header-titles {
                display: flex;
                flex-direction: column;

                .header-title {
                    color: black;
                    font-weight: 500;
                    font-size: 16px;
                }

                .header-sub-title {
                    font-size: 12px;
                }
            }
        }

        .form-items {
            display: flex;
            flex-direction: column;
            margin-top: 10px;
            margin-left: 10px;

            .container {
                display: flex;
                flex-direction: row;
                margin-bottom: 10px;
                flex-wrap: wrap;
                padding: 0;
            }

            .form-item {
                background-color: #eaeaea;
                padding: 5px 7px;
                border-radius: 15px;
                border: 1px solid #cbcbcb;
                margin-right: 5px;
                width: fit-content;
                margin-top: 5px;
                min-width: 50px;
                display: flex;
                align-items: center;
                justify-content: center;

                .form-item-icon {
                    cursor: pointer;
                    font-size: 14px;
                    padding: 3px;
                    border-radius: 5px;

                    &.edit {
                        margin-left: 5px;
                    }

                    &:hover {
                        background-color: #fbfbfb;
                    }
                }
            }
        }
    }
}
</style>
